import { useId } from "react";

export function Logo({
    className,
    variant = "color+primary",
}: {
    className?: string;
    variant?: "color+white" | "color+primary" | "primary" | "pink" | "white";
}) {
    let letterFill: string;
    let iconFill: string;
    switch (variant) {
        case "color+primary":
            letterFill = "#43045F";
            iconFill = "#F43D7F";
            break;
        case "primary":
            letterFill = "#43045F";
            iconFill = "#43045F";
            break;
        case "color+white":
            letterFill = "#F9F3E9";
            iconFill = "#F43D7F";
            break;
        case "white":
            letterFill = "#F9F3E9";
            iconFill = "#F9F3E9";
            break;
        case "pink":
            letterFill = "#FB9CE5";
            iconFill = "#FB9CE5";
            break;

        default:
            throw new Error("Invalid variant");
    }

    const id = useId();

    return (
        <svg
            viewBox="0 0 1589 241"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M1588.03 118.358C1588.03 122.049 1587.77 125.212 1587.5 127.584H1486.28C1487.34 151.307 1503.15 172.921 1530.04 172.921C1549.28 172.921 1558.77 160.796 1563.52 145.508H1585.66C1580.91 167.913 1562.46 191.9 1529.25 191.9C1488.13 191.9 1465.72 159.478 1465.72 122.312C1465.72 80.9289 1491.29 52.7249 1528.72 52.7249C1557.72 52.7249 1588.03 71.9668 1588.03 118.358ZM1530.3 70.6489C1501.57 70.6489 1490.24 88.5729 1487.34 110.714H1566.94C1565.1 85.937 1551.39 70.6489 1530.3 70.6489Z"
                fill={letterFill}
            />
            <path d="M1449.85 0V189.784H1428.76V0H1449.85Z" fill={letterFill} />
            <path
                d="M1290.46 122.312C1290.46 84.0919 1313.92 52.7249 1354.51 52.7249C1389.83 52.7249 1410.66 77.5022 1412.77 103.334H1392.21C1389.57 85.1463 1376.92 71.7033 1355.04 71.7033C1324.99 71.7033 1311.55 94.8991 1311.55 122.312C1311.55 149.726 1324.99 172.921 1355.04 172.921C1376.92 172.921 1389.57 159.478 1392.21 141.291H1412.77C1410.66 167.122 1390.1 191.9 1354.51 191.9C1314.71 191.9 1290.46 160.533 1290.46 122.312Z"
                fill={letterFill}
            />
            <path
                d="M1154.37 152.098C1154.37 122.312 1178.09 113.087 1201.81 110.978C1226.59 108.869 1251.63 110.978 1251.37 95.9534C1251.11 85.4099 1245.83 70.6489 1214.99 70.6489C1191.27 70.6489 1180.99 82.774 1179.14 94.8991H1158.58C1163.33 65.1135 1188.11 52.7249 1217.1 52.7249C1247.42 52.7249 1272.46 63.2684 1272.46 112.823V189.791H1251.37V174.766C1251.37 169.495 1252.16 165.541 1254.01 160.006C1254.8 157.897 1255.59 155.524 1253.48 154.997C1252.16 154.734 1251.37 155.788 1250.84 157.37C1243.73 178.72 1223.43 191.9 1198.65 191.9C1174.66 191.9 1154.37 175.294 1154.37 152.098ZM1251.37 114.405C1243.46 123.63 1222.9 124.685 1202.34 128.111C1186 130.747 1175.45 136.81 1175.45 150.78C1175.45 163.696 1185.47 176.084 1207.35 173.976C1232.65 171.603 1251.11 151.834 1251.37 114.405Z"
                fill={letterFill}
            />
            <path
                d="M1142.78 54.8313V72.7553H1104.82V151.832C1104.82 167.12 1107.98 171.865 1122.74 171.865H1142.78V189.789H1122.74C1094.8 189.789 1083.73 181.618 1083.73 150.25V72.7553H1058.43V54.8313H1083.73V16.8745H1104.82V54.8313H1142.78Z"
                fill={letterFill}
            />
            <path
                d="M937.121 122.31C937.121 84.09 960.581 52.7229 1001.17 52.7229C1036.5 52.7229 1057.32 77.5002 1059.43 103.332H1038.87C1036.23 85.1443 1023.58 71.7013 1001.7 71.7013C971.651 71.7013 958.208 94.8971 958.208 122.31C958.208 149.724 971.651 172.919 1001.7 172.919C1023.58 172.919 1036.23 159.476 1038.87 141.289H1059.43C1057.32 167.12 1036.76 191.898 1001.17 191.898C961.371 191.898 937.121 160.531 937.121 122.31Z"
                fill={letterFill}
            />
            <path
                d="M925.442 118.358C925.442 122.049 925.178 125.212 924.915 127.584H823.695C824.749 151.307 840.565 172.921 867.451 172.921C886.694 172.921 896.183 160.796 900.928 145.508H923.069C918.325 167.913 899.873 191.9 866.661 191.9C825.54 191.9 803.135 159.478 803.135 122.312C803.135 80.9289 828.703 52.7249 866.133 52.7249C895.129 52.7249 925.442 71.9668 925.442 118.358ZM867.715 70.6489C838.983 70.6489 827.649 88.5729 824.749 110.714H904.354C902.509 85.937 888.802 70.6489 867.715 70.6489Z"
                fill={letterFill}
            />
            <path
                d="M663.918 54.8336H685.005V65.3771C685.005 70.1217 684.478 74.6027 682.633 79.8745C681.842 82.2468 680.261 84.6191 682.633 85.4099C684.215 85.937 685.269 83.5647 685.533 82.774C693.44 65.3771 709.256 52.7249 730.871 52.7249C765.929 52.7249 790.443 82.2468 790.443 122.312C790.443 162.378 765.929 191.9 730.871 191.9C709.783 191.9 693.704 179.511 685.533 161.323C685.269 160.533 684.215 158.424 682.37 159.215C680.788 160.005 681.579 162.114 682.37 164.223C684.478 170.022 685.005 173.712 685.005 178.193V240.4H663.918V54.8336ZM727.708 172.921C755.121 172.921 769.355 149.726 769.355 122.312C769.355 94.8991 755.121 71.7032 727.708 71.7032C702.666 71.7032 685.005 94.8991 685.005 122.312C685.005 149.726 702.666 172.921 727.708 172.921Z"
                fill={letterFill}
            />
            <path
                d="M574.485 84.6171C613.233 89.8888 643.81 97.5329 643.81 136.544C643.81 166.593 618.769 191.898 572.113 191.898C520.449 191.898 500.415 158.686 500.415 124.419H523.612C524.139 146.56 532.31 172.919 572.113 172.919C610.597 172.919 620.614 153.677 620.614 138.126C620.614 121.783 610.334 111.503 571.849 106.231C530.729 100.696 506.478 84.3535 506.478 52.7228C506.478 23.728 530.992 2.11377 572.376 2.11377C619.032 2.11377 636.166 31.1085 636.957 61.1577H614.288C614.288 41.6521 604.271 21.0922 571.849 21.0922C538.636 21.0922 529.674 37.9618 529.674 51.1413C529.674 62.4756 534.683 79.0817 574.485 84.6171Z"
                fill={letterFill}
            />
            <path
                d="M16.5586 75.0959L18.4169 62.455C19.1245 57.6412 18.5775 52.7262 16.8287 48.1857L15.2311 44.0377C14.2955 41.6086 12.8134 39.4276 10.8994 37.6635L1.82165 29.2966C0.66055 28.2264 2.58838e-05 26.7193 2.60218e-05 25.1402L2.69578e-05 14.4328C2.72248e-05 11.3786 2.42607 8.87678 5.47863 8.78307L97.2146 5.96702L57.1537 35.6907L16.5586 75.0959Z"
                fill={iconFill}
            />
            <path
                d="M0.565225 25.14C0.565225 26.5611 1.15961 27.9177 2.20453 28.8808L11.2825 37.2479C13.2602 39.0708 14.7916 41.3244 15.7583 43.8343L17.3562 47.9826C19.1399 52.6137 19.698 57.627 18.9762 62.537L17.3601 73.5305L56.7602 35.2851L56.7867 35.2591L56.8171 35.2365L95.4301 6.58746L5.49583 9.34797C2.74859 9.43237 0.565227 11.6842 0.565226 14.4329L0.565225 25.14ZM2.53301e-05 14.4329C2.55971e-05 11.3787 2.42616 8.87644 5.47872 8.78273L97.2146 5.96702L57.1538 35.6908L16.5586 75.0959L18.4171 62.4553C19.1247 57.6414 18.5773 52.7261 16.8286 48.1857L15.2312 44.0375C14.2957 41.6085 12.8133 39.4276 10.8995 37.6636L1.82147 29.2965C0.66045 28.2263 2.42561e-05 26.719 2.43941e-05 25.14L2.53301e-05 14.4329Z"
                fill={iconFill}
            />
            <path
                d="M395.831 77.9221L392.423 61.6558C391.46 57.0613 391.657 52.2994 392.996 47.8002L394.503 42.7345C395.304 40.0435 396.76 37.5934 398.741 35.6041L404.592 29.7286C405.648 28.6692 406.24 27.235 406.24 25.7398L406.24 14.7197C406.24 11.6732 403.826 9.17485 400.781 9.07059L310.156 5.96699L352.129 36.2126L395.831 77.9221Z"
                fill={iconFill}
            />
            <path
                d="M405.675 25.7399C405.675 27.0855 405.142 28.3762 404.192 29.3296L398.341 35.205C396.294 37.2605 394.788 39.7923 393.961 42.573L392.454 47.6386C391.089 52.2279 390.888 57.0855 391.87 61.7719L394.904 76.2567L352.519 35.8039L352.491 35.7769L352.46 35.7537L311.995 6.59571L400.762 9.63553C403.502 9.72937 405.675 11.9777 405.675 14.7194L405.675 25.7399ZM406.24 14.7194L406.233 14.4357C406.088 11.5193 403.73 9.1713 400.781 9.07029L310.156 5.96699L352.129 36.2124L395.831 77.9221L392.423 61.656C391.46 57.0616 391.657 52.2996 392.996 47.8004L394.503 42.7342C395.304 40.0433 396.76 37.5933 398.741 35.6041L404.592 29.7287C405.647 28.6693 406.24 27.235 406.24 25.7399L406.24 14.7194Z"
                fill={iconFill}
            />
            <path
                d="M258.611 183.175C280.523 194.013 299.755 192.293 304.663 192.293V173.64C298.857 173.64 284.207 175.025 266.88 166.455C249.82 158.016 228.957 139.181 213.54 95.984C196.734 48.895 171.509 25.8421 148.009 14.9609C124.858 4.24145 104.415 5.94573 99.495 5.94575V24.5987C105.288 24.5987 121.406 23.1982 140.173 31.8878C158.59 40.4156 180.639 59.2864 195.974 102.255C212.699 149.115 236.432 172.204 258.611 183.175Z"
                fill={`url(#${id})`}
            />
            <path
                d="M32.5191 99.2303C32.5191 75.1327 39.8563 56.6044 51.6366 44.1729C63.3803 31.78 80.3139 24.6185 101.191 24.6185V5.96558C75.8698 5.96558 53.8044 14.7682 38.0988 31.3418C22.43 47.8768 13.8675 71.3178 13.8675 99.2303C13.8675 150.709 55.4644 192.495 106.843 192.495V173.842C65.8247 173.842 32.5191 140.467 32.5191 99.2303Z"
                fill={iconFill}
            />
            <path
                d="M378.952 99.2303C378.952 75.1327 371.615 56.6044 359.834 44.1729C348.091 31.78 331.157 24.6185 310.28 24.6185V5.96558C335.601 5.96558 357.667 14.7682 373.372 31.3418C389.041 47.8768 397.604 71.3178 397.604 99.2303C397.604 150.709 356.007 192.495 304.628 192.495V173.842C345.646 173.842 378.952 140.467 378.952 99.2303Z"
                fill={iconFill}
            />
            <path
                d="M261.828 14.9588C284.978 4.23939 305.422 5.94369 310.342 5.94369V24.5966C304.548 24.5966 288.431 23.1962 269.664 31.8857C251.246 40.4135 229.198 59.2843 213.862 102.253C197.138 149.113 173.405 172.201 151.226 183.172C129.313 194.011 110.081 192.291 105.174 192.291V173.638C110.98 173.638 125.63 175.023 142.957 166.453C160.016 158.014 180.879 139.179 196.296 95.982C213.102 48.8929 238.328 25.8401 261.828 14.9588Z"
                fill={iconFill}
            />
            <defs>
                <linearGradient
                    id={id}
                    x1={304.663}
                    y1={99.1197}
                    x2={99.495}
                    y2={99.1197}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={iconFill} />
                    <stop
                        offset={0.490385}
                        stopColor={iconFill}
                        stopOpacity={0}
                    />
                    <stop offset={1} stopColor={iconFill} />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function Logomark({
    className,
    style,
    variant = "color",
}: {
    className?: string;
    style?: React.CSSProperties;
    variant?: "color" | "primary" | "pink" | "white";
}) {
    let iconFill: string;
    switch (variant) {
        case "color":
            iconFill = "#F43D7F";
            break;
        case "primary":
            iconFill = "#43045F";
            break;
        case "white":
            iconFill = "#F9F3E9";
            break;
        case "pink":
            iconFill = "#FB9CE5";
            break;

        default:
            throw new Error("Invalid variant");
    }

    const id = useId();
    return (
        <svg
            viewBox="0 0 425 196"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            <path
                d="M17.3135 72.407L19.2565 59.1898C19.9965 54.1565 19.4245 49.0174 17.596 44.27L15.9255 39.9329C14.9473 37.3931 13.3976 35.1126 11.3964 33.2682L1.90478 24.5198C0.69075 23.4008 0.000114375 21.825 0.000114519 20.1739L0.000115498 8.97841C0.000115777 5.78496 2.53675 3.16909 5.72848 3.07111L101.647 0.126679L59.7593 31.2054L17.3135 72.407Z"
                fill={iconFill}
            />
            <path
                d="M0.591081 20.1737C0.591081 21.6596 1.21257 23.078 2.30512 24.0851L11.797 32.8336C13.8648 34.7395 15.466 37.0959 16.4768 39.7202L18.1476 44.0576C20.0126 48.8998 20.596 54.1416 19.8414 59.2755L18.1516 70.7702L59.3479 30.7812L59.3756 30.7541L59.4074 30.7304L99.7807 0.775405L5.74647 3.66176C2.87398 3.75001 0.591082 6.10447 0.591082 8.97853L0.591081 20.1737ZM0.000114264 8.97853C0.000114543 5.78508 2.53685 3.16873 5.72858 3.07075L101.647 0.12668L59.7594 31.2054L17.3136 72.407L19.2568 59.1901C19.9967 54.1568 19.4243 49.0174 17.5958 44.27L15.9257 39.9326C14.9475 37.3929 13.3976 35.1126 11.3964 33.2682L1.9046 24.5197C0.690647 23.4007 0.000113141 21.8247 0.000113285 20.1737L0.000114264 8.97853Z"
                fill={iconFill}
            />
            <path
                d="M413.876 75.363L410.313 58.3551C409.306 53.5512 409.512 48.5723 410.912 43.8679L412.488 38.5713C413.325 35.7576 414.847 33.1958 416.919 31.1159L423.037 24.9725C424.14 23.8649 424.76 22.3652 424.76 20.8019L424.76 9.2794C424.76 6.09408 422.235 3.4818 419.052 3.37278L324.295 0.127701L368.182 31.7521L413.876 75.363Z"
                fill={iconFill}
            />
            <path
                d="M424.169 20.802C424.169 22.2089 423.611 23.5585 422.618 24.5553L416.5 30.6986C414.36 32.8478 412.786 35.495 411.921 38.4025L410.345 43.699C408.918 48.4975 408.708 53.5766 409.734 58.4766L412.907 73.6217L368.59 31.3248L368.56 31.2965L368.528 31.2723L326.218 0.785086L419.032 3.96348C421.897 4.06159 424.168 6.4124 424.169 9.2791L424.169 20.802ZM424.76 9.2791L424.752 8.98244C424.601 5.93317 422.136 3.47808 419.052 3.37247L324.295 0.127704L368.182 31.7519L413.876 75.363L410.313 58.3554C409.306 53.5516 409.512 48.5724 410.912 43.8681L412.488 38.571C413.325 35.7574 414.847 33.1957 416.919 31.1158L423.037 24.9726C424.14 23.865 424.759 22.3653 424.76 20.802L424.76 9.2791Z"
                fill={iconFill}
            />
            <path
                d="M270.401 185.415C293.312 196.747 313.421 194.949 318.552 194.949V175.446C312.481 175.446 297.163 176.894 279.046 167.933C261.209 159.11 239.395 139.416 223.275 94.2495C205.703 45.0138 179.328 20.91 154.756 9.53273C130.55 -1.67539 109.175 0.106585 104.031 0.106609V19.6099C110.088 19.6099 126.941 18.1456 146.563 27.2312C165.82 36.1479 188.874 55.8789 204.908 100.806C222.395 149.802 247.21 173.944 270.401 185.415Z"
                fill={`url(#${id})`}
            />
            <path
                d="M34.0017 97.6435C34.0017 72.4474 41.6734 53.0745 53.9907 40.0762C66.2697 27.1185 83.9753 19.6305 105.804 19.6305V0.127197C79.3287 0.127197 56.2573 9.33106 39.8357 26.6602C23.4525 43.949 14.4997 68.4586 14.4997 97.6435C14.4997 151.469 57.993 195.16 111.714 195.16V175.657C68.8256 175.657 34.0017 140.76 34.0017 97.6435Z"
                fill={iconFill}
            />
            <path
                d="M396.228 97.6435C396.228 72.4474 388.556 53.0745 376.239 40.0762C363.96 27.1185 346.254 19.6305 324.425 19.6305V0.127197C350.901 0.127197 373.972 9.33106 390.394 26.6602C406.777 43.949 415.73 68.4586 415.73 97.6435C415.73 151.469 372.236 195.16 318.515 195.16V175.657C361.404 175.657 396.228 140.76 396.228 97.6435Z"
                fill={iconFill}
            />
            <path
                d="M273.764 9.52985C297.97 -1.67827 319.345 0.103727 324.49 0.103728V19.607C318.432 19.607 301.58 18.1427 281.957 27.2283C262.7 36.145 239.646 55.876 223.612 100.803C206.125 149.8 181.31 173.941 158.12 185.411C135.209 196.744 115.1 194.946 109.968 194.946V175.443C116.039 175.443 131.357 176.891 149.474 167.93C167.311 159.107 189.125 139.413 205.245 94.2466C222.817 45.0108 249.193 20.9071 273.764 9.52985Z"
                fill={iconFill}
            />
            <defs>
                <linearGradient
                    id={id}
                    x1={318.552}
                    y1={97.528}
                    x2={104.031}
                    y2={97.528}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={iconFill} />
                    <stop
                        offset={0.490385}
                        stopColor={iconFill}
                        stopOpacity={0}
                    />
                    <stop offset={1} stopColor={iconFill} />
                </linearGradient>
            </defs>
        </svg>
    );
}
